export default __webpack_public_path__ + "static/media/garden-01.a90b9aa9.jpg";